import * as React from 'react';

// tslint:disable:max-line-length
export const ClosePopupIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
    <path
      fill="#7A7A7A"
      fillRule="evenodd"
      d="M6.5 5.056L1.444 0 0 1.444 5.056 6.5 0 11.556 1.444 13 6.5 7.944 11.556 13 13 11.556 7.944 6.5 13 1.444 11.556 0 6.5 5.056z"
    />
  </svg>
);
